import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { fontSizes, fontWeights } from '../../../../theme';
import { InputSize } from '../../types';
import getThemeInputVariant from '../../utils/getThemeInputVariant';

interface Props {
  $size: InputSize;
}

export const InputErrorRoot = styled.span.attrs({
  role: 'alert',
})<Props>`
  ${({ theme, $size, 'aria-hidden': isHidden }) => {
    const variant = getThemeInputVariant(theme, $size);

    return css`
      box-sizing: border-box;
      visibility: ${isHidden ? 'hidden' : 'visible'};
      margin-top: ${variant['message-up-padding']};
      padding-bottom: ${variant['message-down-padding']};
      overflow: hidden;
      color: ${variant.message};
      font-weight: ${fontWeights.regular};
      font-size: ${fontSizes.m};
      line-height: ${rem(16)};
      white-space: nowrap;
      text-align: left;
      text-overflow: ellipsis;
      transition: all 0.1s ease-in-out;
    `;
  }}
`;
